module.exports = __webpack_public_path__ + "static/media/Jeannie Watson.0fb807d1.jpg";